module.exports = __webpack_public_path__ + "static/img/3.d6a04b13.png";